"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/SpamBadge.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');


var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _translation = require('shared/selectors/translation');
var _smsDelivery = require('shared/services/smsDelivery');
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');





/* "Possible spam" under a patient message the classifier marked suspect.
 * The message itself always shows. Admins of the patient's org also get
 * "Block number", which adds the number to the org's block list: it can't
 * text any of the org's lines, and we won't text it. */
const SpamBadge = ({ patientKey }) => {
  const target = _hooks.useAppSelector.call(void 0, 
    state => _translation.selectSpamBlockTarget.call(void 0, state, patientKey),
    _reactredux.shallowEqual,
  )
  const { isOpen, onOpen, onClose } = _useToggle2.default.call(void 0, )
  const [isBlocking, setIsBlocking] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const onBlock = _react.useCallback.call(void 0, () => {
    if (!target) return
    setIsBlocking(true)
    _actions2.default.blockPatientSMS({ OrgKey: target.OrgKey, PatientKey: target.PatientKey })
      .then(() => {
        showSuccessBar('Phone number blocked')
        onClose()
      })
      .catch(() => showWarningBar('Failed to block phone number'))
      .finally(() => setIsBlocking(false))
  }, [target, showSuccessBar, showWarningBar, onClose])

  const confirmCopy = target ? _smsDelivery.makeSpamBlockConfirmCopy.call(void 0, target.PhoneNumber) : ''

  return (
    _react2.default.createElement('div', { className: "spam-badge", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
      , _react2.default.createElement('span', { className: "spam-badge--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "Possible spam" )
      ,  target && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('span', { className: "spam-badge--dot", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "·")
          , _react2.default.createElement('button', { type: "button", className: "spam-badge--action", onClick: onOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
            ,  _smsDelivery.SMS_SPAM_BLOCK_TITLE 
          )
          , _react2.default.createElement(_Modal2.default, {
            isOpen: isOpen,
            onClose: onClose,
            title: _smsDelivery.SMS_SPAM_BLOCK_TITLE,
            size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}

            , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
              ,  confirmCopy 
            )
            , _react2.default.createElement(_Modal.ModalControls, {
              primaryBtnTheme: "danger",
              primaryBtnLabel: "Block",
              secondaryBtnLabel: "Cancel",
              isPrimaryLoading: isBlocking,
              isPrimaryEnabled: !isBlocking,
              onPrimaryBtnClick: onBlock,
              onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
            )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, SpamBadge)
